import * as ServiceVanActions from './actions';
import { RelatedWorkshopSto, ServiceVanMasterDataSto } from '../models/servicevan.model.sto';

export interface ServiceVanDetailsResultEntry {
  serviceVan: ServiceVanMasterDataSto;
  related?: RelatedWorkshopSto[];
}

export interface ServiceVanState {
  pageLoading: Map<string, boolean>;
  // pageFilter: Map<string, IncomingTopicFilter>;
  // pageResult will be loaded everytime the list is initiated
  // results will not be stored for different viewIds, as these
  // can contain changes, so we will load them on-the-fly, but
  // the status of loading and the underlying filter will be
  // stored for different views
  pageResult: {
    loadedAt: Date | null;
    totalCount: number;
    serviceVans: ServiceVanMasterDataSto[];
    workshops: RelatedWorkshopSto[];
    limit: number;
    offset: number;
  } | null;
  detailsLoading: Map<string, boolean>;
  detailsLoadedAt: Map<string, Date>;
  detailsResult: Map<string, ServiceVanDetailsResultEntry>;
}

export const initialState: ServiceVanState = {
  pageLoading: new Map<string, boolean>(),
  pageResult: null,
  detailsLoading: new Map<string, boolean>(),
  detailsLoadedAt: new Map<string, Date>(),
  detailsResult: new Map<string, ServiceVanDetailsResultEntry>(),
};

export function reducer(state = initialState, action: ServiceVanActions.Actions): ServiceVanState {
  switch (action.type) {
    case ServiceVanActions.LOAD_PAGE: {
      const loadPageLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadPageLoadingMap[action?.payload?.viewId] = true;
      return {
        ...state,
        pageLoading: loadPageLoadingMap,
      };
    }
    case ServiceVanActions.LOAD_STOPPED: {
      const loadStoppedLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadStoppedLoadingMap[action?.viewId] = false;
      return {
        ...state,
        pageLoading: loadStoppedLoadingMap,
      };
    }
    case ServiceVanActions.LOAD_PAGE_FAILURE: {
      const loadPageFailureLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadPageFailureLoadingMap[action?.payload?.viewId] = false;
      return {
        ...state,
        pageLoading: loadPageFailureLoadingMap,
      };
    }
    case ServiceVanActions.LOAD_PAGE_SUCCESS: {
      const loadPageSuccessLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadPageSuccessLoadingMap[action?.payload?.viewId] = false;

      return {
        ...state,
        pageLoading: loadPageSuccessLoadingMap,
        pageResult: {
          loadedAt: new Date(),
          totalCount: action?.payload?.serviceVansTotalCount,
          serviceVans: action?.payload?.serviceVans,
          workshops: action?.payload?.workshops,
          limit: action?.payload?.viewFilter.pageSize,
          offset: action?.payload?.offset,
        },
      };
    }
    case ServiceVanActions.LOAD_DETAILS: {
      const loadDetailsLoading: Map<string, boolean> = { ...state.detailsLoading };
      loadDetailsLoading[action?.payload?.aggregateId] = true;
      return {
        ...state,
        detailsLoading: loadDetailsLoading,
      };
    }
    case ServiceVanActions.LOAD_DETAILS_SUCCESS: {
      const loadDetailsSuccessLoading: Map<string, boolean> = { ...state.detailsLoading };
      loadDetailsSuccessLoading[action?.payload?.request?.aggregateId] = false;
      const loadDetailsSuccessLoadedAt: Map<string, Date> = { ...state.detailsLoadedAt };
      loadDetailsSuccessLoadedAt[action?.payload?.request?.aggregateId] = new Date();
      const loadDetailsSuccessResult: Map<string, ServiceVanDetailsResultEntry> = { ...state.detailsResult };
      loadDetailsSuccessResult[action?.payload?.request?.aggregateId] = {
        serviceVan: action?.payload?.response,
        related: action?.payload?.related,
      };
      return {
        ...state,
        detailsLoading: loadDetailsSuccessLoading,
        detailsLoadedAt: loadDetailsSuccessLoadedAt,
        detailsResult: loadDetailsSuccessResult,
      };
    }
    case ServiceVanActions.LOAD_DETAILS_FAILURE:
    case ServiceVanActions.LOAD_DETAILS_STOPPED: {
      const loadDetailsFailedLoading: Map<string, boolean> = { ...state.detailsLoading };
      loadDetailsFailedLoading[action?.payload?.request?.aggregateId] = false;

      return {
        ...state,
        detailsLoading: loadDetailsFailedLoading,
      };
    }
    default:
      return state;
  }
}

export const pageLoading = (state: ServiceVanState) => state?.pageLoading;
export const pageResult = (state: ServiceVanState) => state?.pageResult;

export const serviceVans = (state: ServiceVanState) => state?.pageResult?.serviceVans;
export const serviceVansLoadedAt = (state: ServiceVanState) => state?.pageResult?.loadedAt;

export const detailsLoading = (state: ServiceVanState) => state?.detailsLoading;
export const detailsLoadedAt = (state: ServiceVanState) => state?.detailsLoadedAt;
export const detailsResult = (state: ServiceVanState) => state?.detailsResult;
